import { connect } from 'react-redux';
import { updateRoleSelectionForm } from '../actions';
import RoleSelection from '../components/RoleSelection';
import { getRoleSelectionFormPage } from '../selectors';

const mapStateToProps = state => getRoleSelectionFormPage(state);

const mapDispatchToProps = dispatch => {
    return {
        onRoleSelection: role => {
            dispatch(updateRoleSelectionForm(role));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(RoleSelection);
